/**
 * Shared utility functions for string manipulation
 */

/**
 * Converts a product title to a URL-friendly slug
 * @param title - The product title to convert
 * @returns A URL-friendly slug
 */
export function slugify(title: string): string {
  if (!title) {
    return '';
  }
  
  return title
    .toLowerCase()
    .trim()
    .replace(/[\s\/]+/g, '-')           // Replace spaces and slashes with hyphens
    .replace(/[^a-z0-9\-]/g, '-')       // Replace special chars with hyphens
    .replace(/-+/g, '-')                 // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, '');              // Remove leading/trailing hyphens
}

/**
 * Truncates a string to a specified length and adds ellipsis
 * @param text - The text to truncate
 * @param maxLength - Maximum length before truncation
 * @returns Truncated string with ellipsis if needed
 */
export function truncate(text: string, maxLength: number): string {
  if (!text || text.length <= maxLength) {
    return text;
  }
  
  return text.substring(0, maxLength).trim() + '...';
}

/**
 * Capitalizes the first letter of each word
 * @param text - The text to capitalize
 * @returns Text with first letter of each word capitalized
 */
export function titleCase(text: string): string {
  if (!text) {
    return '';
  }
  
  return text
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
